// PLP Filter Modal JavaScript

class PLPFilterModal {
  constructor(modalId, formId) {
    this.modal = document.getElementById(modalId);
    if (!this.modal) return;
    
    this.form = this.modal.querySelector(`#${formId}`);
    if (!this.form) return;
    
    this.init();
  }

  init() {
    // Handle filter option changes
    this.form.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', (e) => this.handleFilterChange(e));
    });

    // Prevent body scroll when modal is open
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          this.updateBodyScroll();
        }
      });
    });

    observer.observe(this.modal, { attributes: true });
  }

  updateBodyScroll() {
    const anyModalActive = document.querySelector('.plp-filter-modal.active');
    document.body.style.overflow = anyModalActive ? 'hidden' : '';
  }

  handleFilterChange(event) {
    const input = event.target;
    const label = input.closest('label');
    
    // Update active state visually
    if (input.type === 'checkbox') {
      label.classList.toggle('active', input.checked);
    } else if (input.type === 'radio') {
      // Remove active from siblings
      const siblings = input.closest('.plp-sort-options').querySelectorAll('.plp-sort-option');
      siblings.forEach(s => s.classList.remove('active'));
      label.classList.add('active');
    }

    // Submit filters
    this.submitFilters();
  }

  submitFilters() {
    // Collect params from both filter and sort modals
    const filterForm = document.getElementById('PLPFilterModalForm');
    const sortForm = document.getElementById('PLPSortModalForm');
    const params = new URLSearchParams();

    // Add filter form data
    if (filterForm) {
      const filterFormData = new FormData(filterForm);
      for (const [key, value] of filterFormData.entries()) {
        params.append(key, value);
      }
    }

    // Add sort form data
    if (sortForm) {
      const sortFormData = new FormData(sortForm);
      for (const [key, value] of sortFormData.entries()) {
        params.append(key, value);
      }
    }

    // Trigger the facet filter rendering
    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.renderPage(params.toString());
    }
  }
}

// Sync the modal filters with the main facet form state
function syncModalWithFacets() {
  const filterModal = document.getElementById('plpFilterModal');
  const sortModal = document.getElementById('plpSortModal');

  // Sync filter checkboxes
  const mainForm = document.getElementById('FacetFiltersForm');
  if (mainForm && filterModal) {
    mainForm.querySelectorAll('input[type="checkbox"]').forEach(mainInput => {
      const modalInput = filterModal.querySelector(`input[name="${mainInput.name}"][value="${mainInput.value}"]`);
      if (modalInput) {
        modalInput.checked = mainInput.checked;
        modalInput.closest('label').classList.toggle('active', mainInput.checked);
      }
    });
  }

  // Sync sort
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect && sortModal) {
    const modalRadio = sortModal.querySelector(`input[name="sort_by"][value="${sortSelect.value}"]`);
    if (modalRadio) {
      modalRadio.checked = true;
      sortModal.querySelectorAll('.plp-sort-option').forEach(opt => opt.classList.remove('active'));
      modalRadio.closest('label').classList.add('active');
    }
  }
}

// Close modals on escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.plp-filter-modal.active').forEach(modal => {
      modal.classList.remove('active');
    });
    document.body.style.overflow = '';
  }
});

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  new PLPFilterModal('plpFilterModal', 'PLPFilterModalForm');
  new PLPFilterModal('plpSortModal', 'PLPSortModalForm');
  syncModalWithFacets();
});

// Re-sync after facet updates
if (typeof subscribe !== 'undefined') {
  subscribe('facets:updated', syncModalWithFacets);
}
